<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Usuários: Editar e afastamentos
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  editar
        |  um usuário e gerenciar
        strong  afastamentos
        |  em
        strong  Configurações → Usuários
        | .

      .toast.toast-primary
        | A edição exige
        strong  Sistema → Usuários → Alterar
        | . Afastamentos exigem
        strong  Produtividade → Afastamentos → Criar
        |  (o usuário precisa ter
        strong  cargo
        | ).

      h5.h5 1. Abrir a edição
      ol
        li Em
          strong  Listar usuários
          | , no card desejado clique em
          strong  Alterar
          |  — ou, na ficha de exibição, use
          strong  Alterar
          | .
        li O cabeçalho mostra CPF/CNPJ e nome (somente leitura).

      h5.h5 2. Campos editáveis
      figure.manual-figure
        img(:src="imgEdit" alt="Edição do usuário")
      ol
        li Altere
          strong  Email
          |  e
          strong  Nome/Razão social
          | .
        li Ajuste
          strong  Validado por
          |  (rádios).
        li Para pessoa física, use
          strong  Trabalha na prefeitura
          | . Com prefeitura marcada, configure
          strong  Recebe OS-m
          | ,
          strong  Fiscal
          | ,
          strong  Matrícula
          | ,
          strong  Código fiscal
          | ,
          strong  Data admissão
          | ,
          strong  Perfis
          |  (checkboxes),
          strong  Assuntos
          |  e
          strong  Zonas
          | .
        li Selecione
          strong  Usuário grupo
          |  e
          strong  Cargo
          |  nos seletores.
        li Clique em
          strong  Salvar
          | . Você volta à listagem com mensagem de sucesso.
        li O botão
          strong  Exibir
          |  abre a ficha sem salvar.

      h5.h5 3. Afastamentos
      p
        | Na ficha de
        strong  Exibir
        |  do usuário, clique em
        strong  Afastamentos
        |  (desabilitado se não houver cargo).
      figure.manual-figure
        img(:src="imgAfastamentos" alt="Afastamentos do usuário")
      ol
        li Confira a
          strong  Média Mensal
          |  (aviso se for zero ou negativa).
        li A tabela lista início, fim, dias afastado, dias úteis e observação.
        li Clique em
          strong  Novo Afastamento
          | .
        li No modal, informe
          strong  Data inicial
          | ,
          strong  Data final
          |  e
          strong  Observação
          |  (5 a 100 caracteres) e salve.
        li Para remover um período, use o ícone de
          strong  lixeira
          |  e confirme.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgEdit: require("@/assets/manuais/36-config-usuarios-edit.png"),
      imgAfastamentos: require("@/assets/manuais/36a-config-usuarios-afastamentos.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
